import { Injectable } from '@angular/core';
import { toBlob } from 'html-to-image';

@Injectable({ providedIn: 'root' })
export class ImageDownloadService {
  public async downloadSectionAsPng(sectionElement: HTMLElement, sectionName: string): Promise<void> {
    const blob = await this.captureElement(sectionElement);
    const blobUrl = URL.createObjectURL(blob);

    const downloadLink = document.createElement('a');
    downloadLink.download = `incident-insights-${this.toKebabCase(sectionName)}.png`;
    downloadLink.href = blobUrl;
    downloadLink.click();

    URL.revokeObjectURL(blobUrl);
  }

  protected async captureElement(element: HTMLElement): Promise<Blob> {
    const blob = await toBlob(element, {
      cacheBust: true,
      pixelRatio: 1,
      backgroundColor: '#ffffff',
      width: element.offsetWidth,
      height: element.offsetHeight,
    });

    if (!blob) {
      throw new Error('Failed to create PNG blob from html-to-image output.');
    }

    return blob;
  }

  private toKebabCase(input: string): string {
    return input
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }
}
